class ProductQuiz extends HTMLElement {
  constructor() {
    super();

    this.navigation = this.querySelectorAll(".js-navigation");
    this.restart = this.querySelectorAll(".js-restart");
    this.tabs = this.querySelectorAll(".js-tab");
    this.allAnswers = this.querySelectorAll(".js-answer");
    this.crumb = this.querySelector(".js-crumb-wrapper");
    this.crumbs = this.querySelectorAll(".js-crumb");
    this.results = this.querySelectorAll(".js-result");
    this.noResults = this.querySelector(".js-no-results");
    this.images = this.querySelectorAll(".js-quiz-media");
    this.questionContainer = this.querySelector('.product-quiz__content');
    this.mediaContainer = this.querySelector('.product-quiz__media');
    this.summaryDropdowns = this.querySelectorAll(".js-summary-dropdown");
    this.responses = [];
    this.currentIndex = 0;
    this.mostCommonResponse = null;

    this.eventListeners();
  }

  eventListeners() {
    this.navigation.forEach((button) => {
      button.addEventListener("click", this.changeQuestion.bind(this));
    });

    this.restart.forEach((button) => {
      button.addEventListener("click", this.restartQuiz.bind(this));
    });

    this.allAnswers.forEach((answer) => {
      answer.addEventListener("change", this.answerInteraction.bind(this));
    });

    this.summaryDropdowns.forEach((dropdown) => {
      dropdown.addEventListener("change", this.updateAnswer.bind(this));
    });
  }

  changeQuestion(button) {
    const goToIndex = parseFloat(button.currentTarget.dataset.index);
    if (goToIndex > 1) {
      if (goToIndex > this.currentIndex) {
        this.collectAnswers();
      } else {
        this.responses.pop();
      }
    } else {
      this.responses = [];
    }

    this.hideAllQuestions();
    if (this.tabs[goToIndex]) {
      this.tabs[goToIndex].setAttribute("visible", true);
    }
    this.currentIndex = goToIndex;

    this.updateStep(this.currentIndex);
    this.crumb.classList.remove("hidden");

    const totalQuestions = parseFloat(
      button.currentTarget.getAttribute("data-total-questions")
    );

    if (this.currentIndex > totalQuestions) {
      this.showResults();
    }

    // Update Media
    this.changeMedia(this.currentIndex);
  }

  changeMedia(indexToShow) {
    this.images.forEach((image) => {
      image.removeAttribute("visible");
    });
    if (this.images[indexToShow]) {
      this.images[indexToShow].setAttribute("visible", true);
    } else {
      this.images[0].setAttribute("visible", true);
    }
  }

  answerInteraction(answer) {
    this.tabs[this.currentIndex]
      .querySelector(".js-next")
      .removeAttribute("disabled");
    this.currentAnswer = answer.currentTarget.value;
    this.setSummaryAnswer(this.currentAnswer, answer.currentTarget.dataset.index - 1);
  }

  collectAnswers() {
    if (this.currentAnswer) {
      this.responses.push(this.currentAnswer);
    }
  }
  
  setSummaryAnswer(answer, index) {
    this.summaryDropdowns[index].value = answer;
  }

  updateAnswer(dropdown) {
    const selectedValue = dropdown.currentTarget.value;
    const questionIndex = dropdown.currentTarget.dataset.index - 1;

    this.responses[questionIndex] = selectedValue;
  }

  showResults() {
    this.responses.sort((a, b) => a - b);
    let count = 1,
      max = 0;

    for (let i = 1; i < this.responses.length; ++i) {
      if (this.responses[i] === this.responses[i - 1]) {
        count++;
      } else {
        count = 1;
      }
      if (count > max) {
        max = count;
        this.mostCommonResponse = this.responses[i];
      }
    }

    const resultBlocks = [];
    this.results.forEach((result) => {
      if (result.getAttribute("data-answer-type") === this.mostCommonResponse) {
        resultBlocks.push(result);
      }
    });

    this.crumb.classList.add("hidden");

    this.questionContainer.style.display = "none";
    this.mediaContainer.style.display = "none";

    if (resultBlocks.length > 0) {
      resultBlocks[0].style.display = "block";
    } else {
      this.noResults.style.display = "block";
    }
  }

  hideAllQuestions() {
    this.tabs.forEach((question) => {
      question.removeAttribute("visible");
    });
  }

  restartQuiz(button) {
    this.changeQuestion(button);
    this.allAnswers.forEach((answer) => {
      answer.checked = false;
    });
    this.noResults.style.display = "none";
    this.results.forEach((result) => {
      result.style.display = "none";
    });
    this.navigation.forEach((button) => {
      if (button.classList.contains("js-next")) {
        button.setAttribute("disabled", true);
      }
    });
    this.crumb.classList.add("hidden");
    this.responses = [];
    this.questionContainer.style.display = "flex";
    this.mediaContainer.style.display = "block";
  }

  updateStep(index) {
    document.documentElement.style.setProperty("--quiz-active-steps", index);

    this.crumbs.forEach((crumb, i) => {
      if (i < index) {
        crumb.classList.add("active");
      } else {
        crumb.classList.remove("active");
      }
    });
  }
}

customElements.define("product-quiz", ProductQuiz);
